import { AppTitle } from '@/components/atoms/AppTitle/AppTitle'
import { useAppWallet } from '@/shared/wallet/useAppWallet'
import { trackUserAction } from '@/shared/helpers/sentry'
import { useAuthStore } from '@/store'
import { Button, Flex, message } from 'antd'
import React, { useCallback, useEffect } from 'react'
import styles from './AuthWalletConnect.module.scss'
import { AuthStep } from '@/features/Auth/auth.types'

type Props = {
  onBack?: () => void;
  selectedWallet: string;
  setStep: (step: AuthStep) => void;
  type?: 'add';
}

export function AuthWalletConnect({ selectedWallet, setStep, type, onBack }: Props) {
  const wallet = useAppWallet(selectedWallet)
  const setSelectedPublicKey = useAuthStore((state) => state.setSelectedPublicKey)
  const selectedPublicKey = useAuthStore((state) => state.selectedPublicKey)

  const handleWalletConnect = useCallback(async () => {
    trackUserAction('User clicked Connect wallet button', { wallet: selectedWallet })

    if (type === 'add' && wallet.publicKey && wallet.publicKey === selectedPublicKey) {
      message.info('You trying to add same public key, please change it and try again.')
      return
    }

    if (type === 'add' && wallet.publicKey && wallet.publicKey !== selectedPublicKey && wallet.connected) {
      await wallet.disconnect()
    }

    await wallet.connect()
  }, [selectedPublicKey, selectedWallet, type, wallet])

  useEffect(() => {
    if (wallet.connected && wallet.publicKey) {
      setSelectedPublicKey(wallet.publicKey)
      setStep(AuthStep.WALLET_CONNECTED)
    }
  }, [wallet.connected, wallet.publicKey, setSelectedPublicKey, setStep])

  return (
    <Flex vertical justify="center" align="center" className="mobileContainer" gap={36}>
      <>
        <Flex className="w-full" flex={1} gap={15} justify="center" vertical>
          <span className={styles.icon}>🔗</span>
          <AppTitle text={`Connect to ${selectedWallet}`} centered />
          <p className={styles.text}>
            You ll be redirected to the
            {' '}
            {selectedWallet}
            {' '}
            <br />
            wallet and asked for permission.
          </p>
          <p className={styles.text}>
            The GoDefi app is fully decentralized,
            <br />
            {' '}
            so we never access your private key.
          </p>
        </Flex>
        <Flex vertical gap={10} className="mt-auto w-full">
          <Button loading={wallet.connecting} onClick={handleWalletConnect} type="primary" className="mobilePrimaryButton">
            {`Connect to ${selectedWallet}`}
          </Button>
          {onBack && (
            <Button onClick={onBack} className="mobileSecondaryButton">
              Back
            </Button>
          )}
        </Flex>
      </>
    </Flex>
  )
}
